import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SystemSettingMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.systemSetting.home);
  };

  return (
    <MainMenuItem
      itemTitleString="システム設定"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SystemSettingMenuItem;
